(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9928],{

/***/ 44904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ PortableText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(88863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./components/CallToActionSlider/CallToActionSlider.module.css
var CallToActionSlider_module = __webpack_require__(92139);
var CallToActionSlider_module_default = /*#__PURE__*/__webpack_require__.n(CallToActionSlider_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/CallToActionSlider/CallToActionSlider.tsx






var WORRY_SCORE_TEXT = [
    "Very often",
    "Often",
    "Sometimes",
    "Rarely",
    "Never"
];
var SLEEP_QUALITY_TEXT = [
    "Very poor",
    "Poor",
    "Moderate",
    "Great",
    "Excellent"
];
var MENTAL_HEALTH_QUALITY_SCORE_TEXT = [
    "Very Poor",
    "Poor",
    "Moderate",
    "Great",
    "Excellent"
];
function calculateMentalHealthQualityScore(sleepQuality, worryScore) {
    // Possible score range 0 - 4
    var mentalHealthQualityScore = Math.floor((worryScore + sleepQuality) / 2);
    console.log(mentalHealthQualityScore);
    if (worryScore < 2 || sleepQuality < 2) {
        mentalHealthQualityScore = 0;
    } else if (worryScore == 2) {
        mentalHealthQualityScore = 1;
    }
    return mentalHealthQualityScore;
}
function CallToActionSlider(param) {
    var href = param.href;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), sleepQuality = ref[0], setSleepQuality = ref[1];
    var ref1 = (0,react.useState)(0), worryScore = ref1[0], setWorryScore = ref1[1];
    var mentalHealthQualityScore = calculateMentalHealthQualityScore(sleepQuality, worryScore);
    var touched = worryScore > 0 || sleepQuality > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-6 sm:p-10 bg-dawnDark-700 rounded-xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex", "".concat(touched ? "justify-between" : "justify-center")),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-semibold text-white sm:text-2xl font-inter",
                            children: touched ? "Mental Health Quality" : "Check Your Mental Health Quality"
                        })
                    }),
                    touched && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 py-2 bg-white bg-opacity-6 rounded-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-semibold text-white uppercase sm:text-2xl font-inter",
                            children: MENTAL_HEALTH_QUALITY_SCORE_TEXT[mentalHealthQualityScore]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-between space-y-2 sm:space-y-2 sm:flex-row sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base text-white sm:text-xl sm:leading-8 font-inter",
                                        children: "How Is Your Sleep?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-bold text-white sm:text-xl sm:leading-8 font-inter",
                                        children: SLEEP_QUALITY_TEXT[sleepQuality]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                onChange: setSleepQuality,
                                value: sleepQuality,
                                min: 0,
                                max: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-16 space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-between space-y-2 sm:space-y-2 sm:flex-row sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base text-white sm:text-xl sm:leading-8 font-inter",
                                        children: "How often do you feel worry?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-bold text-white sm:text-xl sm:leading-8 font-inter",
                                        children: WORRY_SCORE_TEXT[worryScore]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                onChange: setWorryScore,
                                value: worryScore,
                                min: 0,
                                max: 4
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname: href !== null && href !== void 0 ? href : "/questionnaire",
                        query: {
                            utm_source: router.asPath
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "w-full px-8 py-4 text-center rounded-full sm:w-auto bg-gradient-to-tr from-dawnPurple-500 to-dawnOrange-500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-sans text-sm font-medium leading-none tracking-widest text-white uppercase sm:text-base",
                            children: "Start Feeling Better"
                        })
                    })
                })
            })
        ]
    });
}
function Slider(param) {
    var value = param.value, min = param.min, max = param.max, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full h-2 bg-white rounded bg-opacity-10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-2 rounded-l bg-gradient-to-r from-dawnPurple-500 to-dawnOrange-500",
                style: {
                    width: "".concat(100 / (max - min) * (value - min), "%")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "range",
                className: "absolute appearance-none h-2 w-full bg-transparent ".concat((CallToActionSlider_module_default()).inputRange),
                value: value,
                min: min,
                max: max,
                onChange: function(event) {
                    return onChange(parseInt(event.target.value));
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/PortableText/PortableText.tsx








function BlockNormal(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: text
    });
}
function BlockHeadingTwo(param) {
    var text = param.text, indexPosition = param.indexPosition;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: classnames_default()("font-inter text-2xl font-semibold leading-8 md:text-4xl", {
            "mt-10": [
                "middle",
                "last"
            ].includes(indexPosition)
        }),
        children: text
    });
}
function BlockRenderer(param) {
    var props = param.props, blocks = param.blocks;
    var _node = props.node, _style = _node.style, style = _style === void 0 ? "normal" : _style;
    switch(style){
        case "h2":
            var h2Blocks = blocks.filter(function(block) {
                return block.style === style;
            });
            var index = h2Blocks.findIndex(function(block) {
                return block._key === props.node._key;
            });
            var indexPosition = index === 0 ? "first" : index === h2Blocks.length - 1 ? "last" : "middle";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingTwo, {
                text: props.children,
                indexPosition: indexPosition
            });
        case "normal":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockNormal, {
                text: props.children
            });
        default:
            // @ts-expect-error
            return BlockContent_default().defaultSerializers.types.block(props);
    }
}
function ImageRenderer(param) {
    var props = param.props;
    var ref;
    // @ts-expect-error
    var imageUrl = (props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : ref.asset) ? BlockContent_default().getImageUrl(props) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
        className: "my-10",
        children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: imageUrl,
            alt: "",
            className: "rounded-xl"
        }) : "No image url yet. Try reloading the page."
    });
}
function buildInternalUrl(contentType, slug) {
    return "".concat(contentType === "post" ? "/blog/" : "/").concat(slug);
}
function InternalLinkExtendedRenderer(param) {
    var props = param.props;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _node = props.node, contentType = _node.contentType, slug = _node.slug;
    var imageAsset;
    if (props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : ref.mainImage) {
        imageAsset = props === null || props === void 0 ? void 0 : props.node.mainImage;
    } else if (props === null || props === void 0 ? void 0 : (ref1 = props.node) === null || ref1 === void 0 ? void 0 : ref1.introSection) {
        imageAsset = props.node.introSection.image;
    }
    var text = (props === null || props === void 0 ? void 0 : (ref2 = props.node) === null || ref2 === void 0 ? void 0 : ref2.excerpt) || (props === null || props === void 0 ? void 0 : (ref3 = props.node) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.introSection) === null || ref4 === void 0 ? void 0 : ref4.text);
    var title = (props === null || props === void 0 ? void 0 : (ref5 = props.node) === null || ref5 === void 0 ? void 0 : ref5.title) || "No title";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: buildInternalUrl(contentType, slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex p-4 mt-4 space-x-6 border rounded group md:p-6 border-dawnDark-200",
            children: [
                imageAsset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-24 overflow-hidden rounded w-22 md:w-34 md:h-28",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                            image: imageAsset,
                            fill: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "font-inter",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-base font-semibold md:text-xl md:leading-8 font-inter group-hover:text-dawnPurple-500 line-clamp-1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-dawnDark-400 line-clamp-3",
                            children: text
                        })
                    ]
                })
            ]
        })
    });
}
function ExternalLinkRendererAnnotation(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: props.mark.href ? props.mark.href : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-dawnPurple-500 hover:underline",
            children: props.children[0]
        })
    });
}
function InternalLinkRendererAnnotation(param) {
    var props = param.props;
    var _mark = props.mark, contentType = _mark.contentType, slug = _mark.slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: buildInternalUrl(contentType, slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-dawnPurple-500 hover:underline",
            children: props.children[0]
        })
    });
}
function ListRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: props.children
    });
}
function ListItemRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: props.children
    });
}
function CitationSourceReferenceAnnotationRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "#citation-source-".concat(props.mark.citationSourceReference),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-sm align-top",
            children: props.children
        })
    });
}
function CallToActionSliderRenderer(param) {
    var props = param.props;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActionSlider, {
        href: (ref = props.node) === null || ref === void 0 ? void 0 : ref.href
    });
}
function createSerializers(param) {
    var blocks = param.blocks;
    return {
        types: {
            block: function(props) {
                return BlockRenderer({
                    props: props,
                    blocks: blocks
                });
            },
            image: function(props) {
                return ImageRenderer({
                    props: props
                });
            },
            internalLinkExtended: function(props) {
                return InternalLinkExtendedRenderer({
                    props: props
                });
            },
            callToActionSlider: function(props) {
                return CallToActionSliderRenderer({
                    props: props
                });
            }
        },
        marks: {
            internalLinkAnnotation: function(props) {
                return InternalLinkRendererAnnotation({
                    props: props
                });
            },
            externalLinkAnnotation: function(props) {
                return ExternalLinkRendererAnnotation({
                    props: props
                });
            },
            citationSourceReferenceAnnotation: function(props) {
                return CitationSourceReferenceAnnotationRenderer({
                    props: props
                });
            }
        },
        listItem: function(props) {
            return ListItemRenderer({
                props: props
            });
        },
        list: function(props) {
            return ListRenderer({
                props: props
            });
        }
    };
}
function PortableText(param) {
    var blocks = param.blocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        projectId: sanity/* config.projectId */.vc.projectId,
        dataset: sanity/* config.dataset */.vc.dataset,
        serializers: createSerializers({
            blocks: blocks
        }),
        blocks: blocks,
        imageOptions: {
            w: 672,
            fit: "max"
        }
    });
}

;// CONCATENATED MODULE: ./components/PortableText/index.ts



/***/ }),

/***/ 47849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Intro; },
  "O": function() { return /* reexport */ IntroBase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
;// CONCATENATED MODULE: ./components/page-sections/Intro/Intro.tsx








function Intro(param) {
    var title = param.title, text = param.text, _showCallToAction = param.showCallToAction, showCallToAction = _showCallToAction === void 0 ? true : _showCallToAction, _callToActionText = param.callToActionText, callToActionText = _callToActionText === void 0 ? "Get Started" : _callToActionText, _showTestimonials = param.showTestimonials, showTestimonials = _showTestimonials === void 0 ? false : _showTestimonials, _showInThePressLogos = param.showInThePressLogos, showInThePressLogos = _showInThePressLogos === void 0 ? false : _showInThePressLogos, showHeaderMedia = param.showHeaderMedia, image = param.image, youtubeVideoId = param.youtubeVideoId, internalLinkCallToAction = param.internalLinkCallToAction;
    var buildCallToActionUrl = function buildCallToActionUrl(internalLinkCallToAction) {
        if (internalLinkCallToAction) {
            switch(internalLinkCallToAction._type){
                case "questionnaire":
                    return "/questionnaire/".concat(internalLinkCallToAction.slug.current);
                case "page":
                    return "/".concat(internalLinkCallToAction.slug.current);
                case "post":
                    return "/blog/".concat(internalLinkCallToAction.slug.current);
            }
        }
        return "/questionnaire";
    };
    var hasHeaderMedia = showHeaderMedia && showHeaderMedia !== "none" && (image || youtubeVideoId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-22 xl:pt-30 xl:pb-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex justify-between flex-1 max-w-7xl md:px-7 mx-6", {
                            "xl:flex-row xl:items-center": hasHeaderMedia,
                            "flex-col-reverse": hasHeaderMedia && showHeaderMedia === "image",
                            "flex-col": hasHeaderMedia && showHeaderMedia === "youtubeEmbed"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("w-full", {
                                    "xl:w-7/12 xl:pr-8 xl:mt-0": hasHeaderMedia
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: classnames_default()("xl:text-5.5xl text-5xl leading-12  xl:leading-18 font-semibold text-center xl:text-left", {
                                            "xl:text-center max-w-3xl mx-auto": !hasHeaderMedia
                                        }),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: classnames_default()("font-inter mt-4 text-base text-center xl:leading-8 xl:text-xl xl:text-left", {
                                            "xl:text-center max-w-1.5xl mx-auto": !hasHeaderMedia,
                                            "xl:max-w-lg": hasHeaderMedia
                                        }),
                                        children: text
                                    }),
                                    showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("flex justify-center mt-10 xl:justify-start xl:mt-6", {
                                            "xl:justify-center": !hasHeaderMedia
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: buildCallToActionUrl(internalLinkCallToAction),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full xl:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                                children: callToActionText
                                            })
                                        })
                                    })
                                ]
                            }),
                            showHeaderMedia === "image" && image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mb-10 overflow-hidden xl:flex-1 rounded-xl h-80",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                                    image: image,
                                    fill: true,
                                    width: 400
                                })
                            }),
                            showHeaderMedia === "youtubeEmbed" && youtubeVideoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative xl:pt-[28.5%] pt-[56.2%] w-full xl:w-[60%] overflow-hidden mt-10 xl:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    className: "absolute inset-0 w-full h-full rounded-xl",
                                    src: "https://www.youtube.com/embed/".concat(youtubeVideoId),
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                }),
                showInThePressLogos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePressLogos */.P, {})
                }),
                showTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "xl:mt-30 mt-22",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                })
            ]
        })
    });
}
function IntroBase(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    children
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Intro/index.ts



/***/ }),

/***/ 88542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ MedicallyReviewedBy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88114);
/* harmony import */ var components_PortableText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44904);



function MedicallyReviewedBy(param) {
    var teamMember = param.teamMember;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "flex justify-center mx-8 py-22 md:py-30",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-sm font-medium leading-4 tracking-widest text-center uppercase md:text-base text-dawnPurple-500",
                    children: "Medically reviewed by"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative w-24 h-24 mx-auto mt-10 overflow-hidden rounded-full md:w-22 md:h-22",
                    children: teamMember.image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        image: teamMember.image
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: "stroke-current",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1",
                            d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-6 text-base font-bold leading-6 text-center md:text-xl md:leading-8",
                    children: teamMember.nameWithCredentials || teamMember.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2 text-base leading-6 text-center font-inter md:text-xl md:leading-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_PortableText__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .Y, {
                        blocks: teamMember.bio
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 92139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputRange":"CallToActionSlider_inputRange__0IXs0"};

/***/ })

}]);